import gql from 'graphql-tag'
import api from './apiClient'

export default {
  readAllByEmisor: (emisor, cursor, limit = 10, filter = null) =>
    api
      .send({
        query: gql`
          query readAllByEmisor($emisor: ID!, $cursor: String, $limit: Int, $filter: Filter) {
            Proveedor {
              readAllByEmisor(emisor: $emisor, cursor: $cursor, limit: $limit, filter: $filter) {
                feed {
                  _id
                  nombre
                  nombreComercial
                  cuentaContable
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          limit,
          filter
        }
      })
      .then(result => result.data.data.Proveedor.readAllByEmisor),

  readAll: (cursor, limit = 10, filter = null) =>
    api
      .send({
        query: gql`
          query readAll($cursor: String, $limit: Int, $filter: Filter) {
            Proveedor {
              readAll(cursor: $cursor, limit: $limit, filter: $filter) {
                feed {
                  _id
                  nombre
                  identificacion {
                    tipo {
                      id
                    }
                    numero
                  }

                  nombreComercial
                  ubicacion {
                    provincia {
                      id
                    }
                    canton {
                      id
                    }
                    distrito {
                      id
                    }
                    otrasSenas
                  }
                  telefono {
                    codigoPais
                    numTelefono
                  }

                  correoElectronico

                  codigoMoneda {
                    id
                  }
                  # tag
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          cursor,
          limit,
          filter
        }
      })
      .then(result => result.data.data.Proveedor.readAll),

  create: item =>
    api
      .send({
        query: gql`
          mutation create($item: ProveedorInput!) {
            Proveedor {
              create(input: $item) {
                _id
              }
            }
          }
        `,
        variables: {
          item
        }
      })
      .then(result => result.data.data.Proveedor.create),

  readById: _id =>
    api
      .send({
        query: gql`
          query readById($_id: ID!) {
            Proveedor {
              readById(_id: $_id) {
                _id
                nombre
                identificacion {
                  tipo {
                    id
                  }
                  numero
                }

                nombreComercial
                ubicacion {
                  provincia {
                    id
                  }
                  canton {
                    id
                  }
                  distrito {
                    id
                  }
                  otrasSenas
                }
                telefono {
                  codigoPais
                  numTelefono
                }

                correoElectronico

                codigoMoneda {
                  id
                }

                cuentaContable
                plazoCredito
              }
            }
          }
        `,
        variables: { _id }
      })
      .then(result => result.data.data.Proveedor.readById),

  findByIdentificacion: item =>
    api
      .send({
        query: gql`
          query findByIdentificacion($item: ProveedorInput!) {
            Proveedor {
              findByIdentificacion(input: $item) {
                id: _id #FIXME: debe ser _id
                cuentaContable
              }
            }
          }
        `,
        variables: { item }
      })
      .then(result => result.data.data.Proveedor.findByIdentificacion),

  readByNombreIdentificacion: nid =>
    api
      .send({
        query: gql`
          query readByNombreIdentificacion($nid: String!) {
            Proveedor {
              readByNombreIdentificacion(nid: $nid) {
                id: _id #FIXME: debe ser _id
                nombre
                identificacion {
                  tipo {
                    id
                  }
                  numero
                }
                ubicacion {
                  provincia {
                    id
                  }
                  canton {
                    id
                  }
                  distrito {
                    id
                  }
                  otrasSenas
                }
                # identificacionExtranjero
                nombreComercial
                telefono {
                  codigoPais
                  numTelefono
                }
                correoElectronico
                # exoneracion {
                #   tipoDocumento {
                #     id
                #     value
                #     annotation
                #   }
                #   numeroDocumento
                #   nombreInstitucion
                #   fechaEmision
                #   tarifaExonerada
                #   articulo
                #   inciso
                # }
              }
            }
          }
        `,
        variables: {
          nid
        }
      })
      .then(result => result.data.data.Proveedor.readByNombreIdentificacion),

  delete: input =>
    api
      .send({
        query: gql`
          mutation delete($input: [ID!]!) {
            Proveedor {
              delete(input: $input) {
                _id
                state
                message
              }
            }
          }
        `,
        variables: { input }
      })
      .then(result => result.data.data.Proveedor.delete),

  setCuentaContable: (_id, cuentaContable) =>
    api
      .send({
        query: gql`
          mutation setCuentaContable($_id: ID!, $cuentaContable: ID!) {
            Proveedor {
              setCuentaContable(_id: $_id, cuentaContable: $cuentaContable)
            }
          }
        `,
        variables: {
          _id,
          cuentaContable
        }
      })
      .then(result => result.data.data.Proveedor.setCuentaContable)
}
